<template>
  <swiper class="swiper home_swiper" :options="swiperOption" v-if="imgLists.length>0">
    <swiper-slide v-for="(item,index) in imgLists" :key="index">
<!--      <div :class="{'anmites':index==0}" class="box_titles">日<span>升</span>月恒 · <span>和</span>衷共济</div>-->
<!--      <div :class="{'anmites':index==0}" class="tips">——诚信立足创新致远——</div>-->
      <img :src="item">
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import {GetBanner} from "../api/apis";

export default {
  name: "banner",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      imgLists: [],
      swiperOption: {
        autoplay: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      }
    }
  },
  mounted() {
    this.getBanner()
  },
  methods: {
    //获取首页banner图
    getBanner() {
      GetBanner().then(res => {
        this.imgLists = res.data.banner
      })
    }
  }

}
</script>

<style scoped lang="less">
.swiper {
  position: relative;
  height: 700px;
  transition: all 0.3s linear;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .box_titles {
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    top: 274px;
    z-index: 5;
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    text-shadow: 0px 0px 4px rgba(14, 118, 187, 0.78);

    span {
      font-size: 54px;
      font-weight: bold;
    }

  }

  .tips {
    width: 285px;
    height: 33px;
    background: #FFFFFF;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 33px;
    color: #60CDF5;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    top: 356px;
    text-align: center;
  }

  .anmites {
    animation: mymove 3s;
    -webkit-animation: mymove 3s; /*Safari and Chrome*/
  }

}

@keyframes mymove {
  0% {
    left: 0;
  }
  100% {
    left: 50%;
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    left: 0;
  }
  100% {
    left: 50%;
  }
}

@media (max-width: 1200px) {
  .swiper {
    height: 136px;
    transition: all 0.3s linear;

    .box_titles {
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      top: 49px;
      z-index: 5;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      text-shadow: 0px 0px 4px rgba(14, 118, 187, 0.78);

      span {
        font-size: 16px;
        font-weight: bold;
      }
    }

    .tips {
      padding: 2px;
      width: auto;
      height: auto;
      background: #FFFFFF;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      font-size: 8px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 12px;
      color: #60CDF5;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      top: 72px;
      text-align: center;
    }
  }
}
</style>
<style lang="less">
.home_swiper {
  .swiper-pagination {
    bottom: 25px;

    .swiper-pagination-bullet {
      width: 12px !important;
      height: 12px !important;
    }
  }
}
@media (max-width: 1200px) {
  .home_swiper {
    .swiper-pagination {
      bottom: 5px;
      .swiper-pagination-bullet {
        width: 4px !important;
        height: 4px !important;
      }
    }
  }
}
</style>
